import Typography from '../../../components/Typography/Typography';
// External library imports
import _ from 'lodash';
// Css module imports
import classes from '../../../styles/CapacityContent.module.css';
import CustomTooltip from '../../../components/CustomToolTip/CustomTooltip';
import { getColumnWithSlotSize } from '../../../utils/biddingHelper';
import economicsClasses from '../Economics.module.css';

const CapacityContent = ({ data }) => {
    const panicHours = _.get(data, ['panicHours'], []);
    const length = _.get(data, ['overall'], []).length || 24;
    const slots = Array.from({ length: length }, (__, i) => i);
    const columns = getColumnWithSlotSize(slots, 8);

    return (
        <div className={`${classes.CapacityContent} ${classes.InfoModalContainer}`}>
            <div>
                <div className={classes.InfoModalHeading}>
                    <Typography content={'Bid Capacity'} size={14} />
                </div>
                <div className={classes.Content}>
                    <div className={classes.ContainerStart}>
                        {columns.map((column, colIndex) => (
                            <table key={colIndex}>
                                <thead>
                                    <tr>
                                        <th>Slot</th>
                                        <th>Hour</th>
                                        <th>Capacity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {column.map((key) => (
                                        <tr key={key}>
                                            <td>{key + 1}</td>
                                            <td>
                                                {key}-{key + 1}
                                            </td>
                                            <td className={economicsClasses.EnergyContainer}>
                                                {_.get(data, ['overall', key])}
                                                <CustomTooltip content={'Out of market'}>
                                                    <span className="required">{panicHours.includes(`HOUR__${key}`) ? '*' : ''}</span>
                                                </CustomTooltip>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CapacityContent;
